export const REG_MAPPING_USER_ROLES = {
  REG_MAPPING_ADMIN: 'RegMapping.AdminUser',
};

export const allRegMappingUserRoles = [REG_MAPPING_USER_ROLES.REG_MAPPING_ADMIN];
